import styled, { keyframes } from 'styled-components'

import { TradingPairHeaderSkeleton } from './trading-pair-header/trading-pair-header-skeleton'

export const TradingPairViewSkeleton: React.FC = () => (
  <Root>
    <TradingPairHeaderSkeleton />
    <TradingPairViewChartSkeleton />
    <HandleContainer>
      <Handle />
    </HandleContainer>
  </Root>
)

const Root = styled.div``

const Keyframes = keyframes`
0% {
    transform: translateX(-100%);
  }
50% {
    transform: translateX(100%);
  }
100% {
    transform: translateX(100%);
  }
`

export const TradingPairViewChartSkeleton = styled.div`
  position: relative;
  background: rgba(255, 255, 255, 0.13);
  overflow: hidden;
  border-radius: 0;
  width: 100%;
  height: 210px;

  &:after {
    animation: 1.5s linear 0.2s infinite normal none running ${Keyframes};
    background: linear-gradient(
      90deg,
      transparent,
      rgba(255, 255, 255, 0.08),
      transparent
    );
    content: '';
    position: absolute;
    transform: translateX(-100%);
    inset: 0px;
  }
`

const Handle = styled.div`
  width: 32px;
  height: 3px;
  background: rgba(255, 255, 255, 0.5);
  border-radius: 2px;
`

const HandleContainer = styled.div`
  padding-block: 8px 8px;
  display: flex;
  justify-content: center;
  touch-action: none;
  transition: all 0.15s linear;
  &:hover {
    background: rgba(255, 255, 255, 0.05);
  }
`
